import React from 'react';
import PageContent from './PageContent';

const TermsConditions = () => {
  return <PageContent tag='TERMS_CONDITIONS_WD' id='5e1edae729f787cb8a9eecd8'/>;
}

export default TermsConditions;